<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：ファイルアップロード画面(FMUpload)                                                               _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <div
    class="overlay"
    :class="[isUploadDlgShow ? showClass : hideClass]"
    id="popup-import"
    ref="content"
  >
    <div class="popup" style="width: 650px">
      <div class="popup-body blue">
        <div
          class="frm-row"
          @dragenter="dragEnter"
          @dragleave="dragLeave"
          @dragover.prevent
          @drop.prevent="dropFile"
        >
          <div class="frm-file">
            <span class="frm-file-text">
              ここにファイルをドロップしてください。
              <br />または
            </span>
            <label class="frm-file-label">
              <input
                class="frm-file-item"
                tabindex="-1"
                type="file"
                accept=".*"
                ref="file"
                @click="
                  (e) => {
                    e.target.value = '';
                  }
                "
                @change="selectedFile"
                multiple="multiple"
              />
              <span
                class="frm-btn"
                type="button"
                tabindex="0"
                ref="selectButton"
                @keydown.space.stop.prevent="$refs['file'].click()"
                >ファイルの選択</span
              >
            </label>
          </div>
        </div>
        <div class="frm-row" v-for="(file, index) in files" :key="index">
          <span class="frm-label w-140px">
            <strong v-if="index == 0">ファイル名</strong>
            <strong v-else></strong>
          </span>
          <span class="frm-label">{{ file.name }}</span>
        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <!--
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="importFile"
              :disabled="isDisabled"
            >
              登録
            </button>
            -->
            <button
              tabindex="0"
              class="frm-btn large"
              @click="handleCancel"
              @blur="onblur"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <STFMFM02C16FileUploadComfirm
  :isFileUploadDlgShow=STFMFM02C16Modle.isFileUploadDlgShow
    :uploadFiles=STFMFM02C16Modle.uploadFiles
    @confirm="confirm"
    @disagree="disagree">
  </STFMFM02C16FileUploadComfirm>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Common from "@/util/common.js";


import STFMFM02C16FileUploadComfirm from "@/components/STFMFM02C16FileUploadComfirm.vue";

export default {
  name: "SFMFileUpload",
  components: {
    STFMFM02C16FileUploadComfirm,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      isEnter: false,
      files: [],
      errors: [],
      targetInfo: "",
      infoNameArea: "",
      infoNameAddArea: "",
      uploadFiles: [],
      STFMFM02C16Modle:{},
    };
  },
  created() {

  },
  computed: {
    ...mapState("businessModule", ["uploadDlgFlag"]),
    ...mapGetters("businessModule", ["isUploadDlgShow"]),
    // **********************************************
    // * ボタン活性、非活性
    // **********************************************
    isDisabled() {
      return this.files.length == 0 ? true : false;
    },
  },
  watch: {
    uploadDlgFlag: function(newVal) {
      if (newVal) {
        this.$nextTick(function() {
          this.initFocus();
        });
      } 
    },
  },
  methods: {
    ...mapMutations("businessModule", ["uploadDialogue", "processDialogue"]),
    ...mapActions("businessModule", ["showProcessDialogue"]),
    onblur(e) {
      if (!e) return;
      e.preventDefault();
      const focusable = this.$refs.content.querySelectorAll(
        '[tabindex]:not([tabindex="-1"])'
      );
      // Find and focus the first available element inside the dialog
      const el = [...focusable].find((el) => !el.hasAttribute("disabled"));
      el && el.focus();
    },
    disagree(){
      this.STFMFM02C16Modle.isFileUploadDlgShow = false;
      this.$nextTick(function () {
        this.initFocus();
      });
    },
    // **********************************************
    // * ファイルの選択
    // **********************************************
    selectedFile(e) {
      this.clearError();

      let file = e.target.files || e.dataTransfer.files;
      this.fileProcessing(file);

      this.importFile();
    },
    // **********************************************
    // * 領域にドラッグが入った時に実行
    // **********************************************
    dragEnter() {
      this.isEnter = true;
    },
    // **********************************************
    // * 領域からドラッグが出た時に実行
    // **********************************************
    dragLeave() {
      this.isEnter = false;
    },
    dragOver() {},
    // **********************************************
    // * 領域でドラッグしているものをドロップしたら実行
    // **********************************************
    dropFile(e) {
      this.clearError();
      let file = e.dataTransfer.files;
      for (var i = 0, f; (f = file[i]); i++) {
        // iterate in the files dropped
        if (!f.type && f.size % 4096 == 0) {
          // The file is a folder
          this.errors.push(
            Common.createError("MTCL1048", Common.getMessage("MTCL1048", []))
          );
          return;
        }
      }

      this.fileProcessing(file);

      this.isEnter = false;

      this.importFile();
    },
    // **********************************************
    // * インポートファイル
    // **********************************************
    importFile() {
      let filesList = this.files;

      if (!filesList.length) return;

      let fileName = filesList[0].name.split(".");
      let suffix = fileName[fileName.length - 1];

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      // let formData = new FormData();
      // for (let i = 0; i < filesList.length; i++) {
      //   formData.append("Files", filesList[i], filesList[i].name);
      // }
      //formData.append("PageID", this.pageId);
      //formData.append("TaxFilingDataId", this.taxFilingDataId);

      this.STFMFM02C16Modle={
      //  isFileUploadDlgShow: true,
        uploadFiles: this.files,
      };     

      // インポートボタン 非活性化
      this.isDisabled = true;

      this.uploadDialogue(false);
    },
    // **********************************************
    // * キャンセルボタンをクリック
    // **********************************************
    handleCancel() {
      // 初期化
      this.clearError();
      this.uploadDialogue(false);
    },
    // **********************************************
    // * エラーメッセージ、ファイルの初期化処理
    // **********************************************
    clearError() {
      this.files = [];
      this.errors = [];
    },
    // **********************************************
    // * ファイル処理共通
    // **********************************************
    fileProcessing(file) {
      this.files = file;
      /*
      let fileName = file[0].name.split(".");
      let suffix = fileName[fileName.length - 1];

      // 「'xlsx', 'csv'」以外場合
      if (!_.includes(["xlsx", "csv"], suffix)) {
        this.files.push(file[0]);
        this.errors.push(
          Common.createError("MTCL1048", Common.getMessage("MTCL1048", []))
        );
        return;
      }

      if (_.isEmpty(this.files)) {
        this.files.push(file[0]);
      } else {
        const index = _.findIndex(this.files, (x) => {
          return _.eq(x.name, file[0].name);
        });
        // 結果が見つからなかったとき
        if (index < 0) {
          this.files.push(file[0]);
        }
      }
      */
    },
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.selectButton.focus();
    },
  },
};
</script>
